var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5249 3.89502L3.9999 2.75002V7.25002L5.5249 6.10502L6.9999 5.00002L5.5249 3.89502ZM5.5249 3.89502L3.9999 2.75002V7.25002L5.5249 6.10502L6.9999 5.00002L5.5249 3.89502ZM5.5249 3.89502L3.9999 2.75002V7.25002L5.5249 6.10502L6.9999 5.00002L5.5249 3.89502ZM4.4999 1.03502V0.0250244C3.4949 0.125024 2.5799 0.525025 1.8399 1.13002L2.5499 1.84502C3.1049 1.41502 3.7699 1.12502 4.4999 1.03502ZM1.8449 2.55002L1.1299 1.84002C0.524902 2.58002 0.124902 3.49502 0.0249023 4.50002H1.0349C1.1249 3.77002 1.4149 3.10502 1.8449 2.55002ZM1.0349 5.50002H0.0249023C0.124902 6.50502 0.524902 7.42002 1.1299 8.16002L1.8449 7.44502C1.4149 6.89502 1.1249 6.23002 1.0349 5.50002V5.50002ZM1.8399 8.87002C2.5799 9.47502 3.4999 9.87503 4.4999 9.97503V8.96502C3.7699 8.87502 3.1049 8.58502 2.5499 8.15502L1.8399 8.87002V8.87002ZM9.9999 5.00002C9.9999 7.58002 8.0399 9.71003 5.5249 9.97503V8.96502C7.4849 8.70502 8.9999 7.02502 8.9999 5.00002C8.9999 2.97502 7.4849 1.29502 5.5249 1.03502V0.0250244C8.0399 0.290024 9.9999 2.42002 9.9999 5.00002Z",
    fill: "#E3E3E3",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.09331a4b68ca58543165ee79aa1b80ae.svg";
export { ForwardRef as ReactComponent };